import { render } from "./lightning-yellow.vue?vue&type=template&id=6edb21ee"
const script = {}

import exportComponent from "/Users/emilyyork/Work/Sneak-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__